import { render, staticRenderFns } from "./GenderRule.vue?vue&type=template&id=8f4f991a&"
import script from "./GenderRule.vue?vue&type=script&lang=js&"
export * from "./GenderRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports